"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cw1CosmWasmClient = void 0;
const signingcosmwasmclient_1 = require("./signingcosmwasmclient");
class Cw1CosmWasmClient extends signingcosmwasmclient_1.SigningCosmWasmClient {
    constructor(apiUrl, signerAddress, signer, cw1ContractAddress, gasPrice, gasLimits, broadcastMode) {
        super(apiUrl, signerAddress, signer, gasPrice, gasLimits, broadcastMode);
        this.cw1ContractAddress = cw1ContractAddress;
    }
    async getAccount(address) {
        return super.getAccount(address || this.cw1ContractAddress);
    }
    async canSend(msg, address = this.signerAddress) {
        const result = await this.queryContractSmart(this.cw1ContractAddress, {
            can_send: {
                sender: address,
                msg: msg,
            },
        });
        return result.can_send;
    }
    async executeCw1(msgs, memo = "") {
        const handleMsg = {
            execute: {
                msgs: msgs,
            },
        };
        return this.execute(this.cw1ContractAddress, handleMsg, memo);
    }
}
exports.Cw1CosmWasmClient = Cw1CosmWasmClient;
//# sourceMappingURL=cw1cosmwasmclient.js.map